@if (messages) {
  <div class="messages-container">
    @for (message of messages; track message) {
      <div class="ui message" [ngClass]="message.type">
        {{message.text}}
      </div>
    }
  </div>
}
